import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DetailItemTitleContainer = styled.div<React.CSSProperties>`
  margin-right: ${16 * Screen.widthRatio}px;
  text-align: end;
`;

export default DetailItemTitleContainer;
